<ion-toolbar>
  <ion-buttons *ngIf="!info.principalPage" slot="start">
    <ng-content></ng-content>
  </ion-buttons>
  <ion-buttons *ngIf="info.principalPage" class="ion-hide-md-up" slot="start">
    <ion-button (click)="openMenu()">
      <ion-icon size="large" name="menu" [color]="iconColor"></ion-icon>
    </ion-button>
  </ion-buttons>
  <ion-buttons slot="end">
    <ion-button *ngIf="info.secondIcon" (click)="secondIconClicked.emit()">
      <ion-icon size="large" [name]="info.secondIcon" [color]="iconColor"></ion-icon>
      <!-- <ion-badge *ngIf="info.messages" color="danger">{{ info.messages }}</ion-badge> -->
    </ion-button>
    <ion-button *ngIf="info.icon" (click)="iconClicked.emit()" class="principal-icon">
      <ion-icon size="large" [name]="info.icon" [color]="iconColor"></ion-icon>
      <ion-badge *ngIf="info.messages" color="danger">{{ info.messages }}</ion-badge>
    </ion-button>
    <ion-button *ngIf="info.text" (click)="iconClicked.emit()">
      {{ info.text }}
    </ion-button>
  </ion-buttons>
  <ion-avatar *ngIf="info.imagen" slot="start" class="md hydrated"
    style="margin: 3px 0 0 0;padding-left: 20px;height: 100%;">
    <img [src]="info.imagen">
  </ion-avatar>
  <ion-title [ngClass]="{'header-title-with-image': info.imagen}">
    {{ info.title }}
    <div *ngIf="info.subtitle" class="subtitle truncate-text">
      <small>{{ info.subtitle }}</small>
    </div>
  </ion-title>
</ion-toolbar>